import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {apiHost} from "../apiData";
import {getLanguage} from "../locales/langUtils";
import {parseOrReject} from "../utils/utils";

export const filter = createAsyncThunk(
    'filtering/filter',
    async (credentials, {rejectWithValue}) => {
        const path = credentials.path;
        const value = credentials.value;
        const response = await fetch(`${apiHost}/api/${path}/filter`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': getLanguage()
            },
            body: value,
            credentials: 'include'
        });

        return await parseOrReject(response, rejectWithValue);
    }
);

export const filteringSlice = createSlice(
    {
        name: 'filter',
        initialState: {
            isLoading: false,
        },
        extraReducers: (builder) => {
            builder
                .addCase(filter.pending, state => {
                    state.isLoading = true;
                })
                .addCase(filter.fulfilled, state => {
                    state.isLoading = false;
                    state.removalError = {};
                })
                .addCase(filter.rejected, (state, action) => {
                    state.isLoading = false;
                    state.removalError = action.payload;
                })
        }
    });


const filteringReducer = filteringSlice.reducer;

export default filteringReducer;